// extracted by mini-css-extract-plugin
module.exports = {"notAvailable":"NotAvailable_notAvailable___P3TC","recsPanelWrapper":"NotAvailable_recsPanelWrapper__J_PFP"};